var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"shouyu"},[_c('activity',{attrs:{"group":"shouyou","rule":_vm.rule,"range":_vm.range}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }